/* src/routes/projects/p5-typescript-starter.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import OpenInGithub from "../../../_components/Open-In-Github.svelte.js";

function create_default_slot_1(ctx) {
	let h1;
	let t0;
	let t1;
	let p0;
	let t2;
	let a0;
	let t3;
	let t4;
	let a1;
	let t5;
	let t6;
	let t7;
	let h20;
	let t8;
	let t9;
	let p1;
	let strong0;
	let a2;
	let t10;
	let t11;
	let p2;
	let img;
	let img_src_value;
	let t12;
	let p3;
	let t13;
	let a3;
	let t14;
	let t15;
	let t16;
	let h21;
	let t17;
	let t18;
	let h30;
	let t19;
	let t20;
	let prism0;
	let t21;
	let prism1;
	let t22;
	let h31;
	let t23;
	let t24;
	let prism2;
	let t25;
	let p4;
	let t26;
	let a4;
	let t27;
	let t28;
	let t29;
	let h22;
	let t30;
	let t31;
	let h32;
	let t32;
	let t33;
	let p5;
	let t34;
	let a5;
	let t35;
	let t36;
	let t37;
	let p6;
	let t38;
	let strong1;
	let t39;
	let t40;
	let t41;
	let p7;
	let t42;
	let t43;
	let blockquote;
	let p8;
	let t44;
	let t45;
	let p9;
	let t46;
	let t47;
	let h40;
	let t48;
	let t49;
	let prism3;
	let t50;
	let h41;
	let t51;
	let t52;
	let prism4;
	let t53;
	let p10;
	let t54;
	let t55;
	let h33;
	let t56;
	let t57;
	let p11;
	let t58;
	let a6;
	let t59;
	let t60;
	let t61;
	let ol0;
	let li0;
	let p12;
	let t62;
	let code0;
	let t63;
	let t64;
	let t65;
	let li1;
	let p13;
	let t66;
	let code1;
	let t67;
	let t68;
	let code2;
	let t69;
	let t70;
	let t71;
	let prism5;
	let t72;
	let ol1;
	let li2;
	let t73;
	let code3;
	let t74;
	let t75;
	let t76;
	let prism6;
	let t77;
	let ol2;
	let li3;
	let t78;
	let code4;
	let t79;
	let t80;
	let t81;
	let prism7;
	let t82;
	let p14;
	let t83;
	let a7;
	let t84;
	let t85;
	let t86;
	let h23;
	let t87;
	let t88;
	let p15;
	let t89;
	let a8;
	let t90;
	let t91;
	let current;

	prism0 = new Prism({
			props: {
				language: "csharp",
				code: `git clone https://github.com/Gaweph/p5-typescript-starter.git
`
			}
		});

	prism1 = new Prism({
			props: {
				language: "csharp",
				code: `npm install
`
			}
		});

	prism2 = new Prism({
			props: {
				language: "csharp",
				code: `npm start
`
			}
		});

	prism3 = new Prism({
			props: {
				language: "csharp",
				code: `let x = 100;
let y = 100;

function setup() {
  createCanvas(windowWidth, windowHeight);
}

function draw() {
  background(0);
  fill(255);
  rect(x, y, 50, 50);
}
`
			}
		});

	prism4 = new Prism({
			props: {
				language: "csharp",
				code: `var sketch = (p: p5) => {
  this.x = 100;
  this.y = 100;
  p.setup = () => {
    p.createCanvas(p.windowWidth, p.windowHeight);
  };

  p.draw = () => {
    p.background(0);
    p.fill(255);
    p.rect(this.x, this.y, 50, 50);
  };
};

new p5(sketch);
`
			}
		});

	prism5 = new Prism({
			props: {
				language: "csharp",
				code: `</script>
`
			}
		});

	prism6 = new Prism({
			props: {
				language: "csharp",
				code: `   import qrcode = require('qrcode-generator');
`
			}
		});

	prism7 = new Prism({
			props: {
				language: "csharp",
				code: `   var qr = qrcode(4, 'L');
   qr.addData('https://github.com/Gaweph/p5-typescript-starter');
   qr.make();

   text(qr.createASCII(), 1, 1);
`
			}
		});

	return {
		c() {
			h1 = element("h1");
			t0 = text("P5 TypeScript Starter");
			t1 = space();
			p0 = element("p");
			t2 = text("This project will quickly get you something working in ");
			a0 = element("a");
			t3 = text("p5.js");
			t4 = text(" and ");
			a1 = element("a");
			t5 = text("typescript");
			t6 = text(".");
			t7 = space();
			h20 = element("h2");
			t8 = text("Demo");
			t9 = space();
			p1 = element("p");
			strong0 = element("strong");
			a2 = element("a");
			t10 = text("Click here for Demo");
			t11 = space();
			p2 = element("p");
			img = element("img");
			t12 = space();
			p3 = element("p");
			t13 = text("This demo is based on the ");
			a3 = element("a");
			t14 = text("Regular Polygon");
			t15 = text(" sketch available in the p5js examples.");
			t16 = space();
			h21 = element("h2");
			t17 = text("Getting Started");
			t18 = space();
			h30 = element("h3");
			t19 = text("Installing");
			t20 = space();
			create_component(prism0.$$.fragment);
			t21 = space();
			create_component(prism1.$$.fragment);
			t22 = space();
			h31 = element("h3");
			t23 = text("Using");
			t24 = space();
			create_component(prism2.$$.fragment);
			t25 = space();
			p4 = element("p");
			t26 = text("A local version will now be running on ");
			a4 = element("a");
			t27 = text("localhost:3000");
			t28 = text(".");
			t29 = space();
			h22 = element("h2");
			t30 = text("Advanced");
			t31 = space();
			h32 = element("h3");
			t32 = text("Global and Instanced Modes");
			t33 = space();
			p5 = element("p");
			t34 = text("P5 is able to run in either ");
			a5 = element("a");
			t35 = text("global or instance mode");
			t36 = text(".");
			t37 = space();
			p6 = element("p");
			t38 = text("This starter project uses ");
			strong1 = element("strong");
			t39 = text("global mode");
			t40 = text(" by default to bring it in line with most of the online resources provided by the project.");
			t41 = space();
			p7 = element("p");
			t42 = text("As stated on the P5 wiki:");
			t43 = space();
			blockquote = element("blockquote");
			p8 = element("p");
			t44 = text("While this is convenient (and friendlier) it's important to note that this can lead to problems and confusion down the road when mixing other JS libraries or trying to embed multiple p5 sketches on the same page. A safer, more advanced methodology is to create a p5 sketch as an object \"instance\".");
			t45 = space();
			p9 = element("p");
			t46 = text("The following examples are both functionally the same.");
			t47 = space();
			h40 = element("h4");
			t48 = text("Global Mode");
			t49 = space();
			create_component(prism3.$$.fragment);
			t50 = space();
			h41 = element("h4");
			t51 = text("Instanced Mode");
			t52 = space();
			create_component(prism4.$$.fragment);
			t53 = space();
			p10 = element("p");
			t54 = text("This starter project will work with either mode, feel free to experiment with both.");
			t55 = space();
			h33 = element("h3");
			t56 = text("Using External Libraries");
			t57 = space();
			p11 = element("p");
			t58 = text("To use an external library, e.g. ");
			a6 = element("a");
			t59 = text("qrcode-generator");
			t60 = text(".");
			t61 = space();
			ol0 = element("ol");
			li0 = element("li");
			p12 = element("p");
			t62 = text("Install the library with ");
			code0 = element("code");
			t63 = text("npm install --save-dev qrcode-generator");
			t64 = text(".");
			t65 = space();
			li1 = element("li");
			p13 = element("p");
			t66 = text("Add a ");
			code1 = element("code");
			t67 = text("script");
			t68 = text(" tag to your ");
			code2 = element("code");
			t69 = text("index.html");
			t70 = text(".");
			t71 = space();
			create_component(prism5.$$.fragment);
			t72 = space();
			ol1 = element("ol");
			li2 = element("li");
			t73 = text("Import via ");
			code3 = element("code");
			t74 = text("global.d.ts");
			t75 = text(".");
			t76 = space();
			create_component(prism6.$$.fragment);
			t77 = space();
			ol2 = element("ol");
			li3 = element("li");
			t78 = text("Use in ");
			code4 = element("code");
			t79 = text("sketch.ts");
			t80 = text(".");
			t81 = space();
			create_component(prism7.$$.fragment);
			t82 = space();
			p14 = element("p");
			t83 = text("See ");
			a7 = element("a");
			t84 = text("dblock/p5qr");
			t85 = text(" for a working sample.");
			t86 = space();
			h23 = element("h2");
			t87 = text("Copyright and License");
			t88 = space();
			p15 = element("p");
			t89 = text("MIT License, see ");
			a8 = element("a");
			t90 = text("LICENSE");
			t91 = text(" for details.");
			this.h();
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", { id: true });
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "P5 TypeScript Starter");
			h1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "This project will quickly get you something working in ");
			a0 = claim_element(p0_nodes, "A", { href: true });
			var a0_nodes = children(a0);
			t3 = claim_text(a0_nodes, "p5.js");
			a0_nodes.forEach(detach);
			t4 = claim_text(p0_nodes, " and ");
			a1 = claim_element(p0_nodes, "A", { href: true });
			var a1_nodes = children(a1);
			t5 = claim_text(a1_nodes, "typescript");
			a1_nodes.forEach(detach);
			t6 = claim_text(p0_nodes, ".");
			p0_nodes.forEach(detach);
			t7 = claim_space(nodes);
			h20 = claim_element(nodes, "H2", { id: true });
			var h20_nodes = children(h20);
			t8 = claim_text(h20_nodes, "Demo");
			h20_nodes.forEach(detach);
			t9 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			strong0 = claim_element(p1_nodes, "STRONG", {});
			var strong0_nodes = children(strong0);
			a2 = claim_element(strong0_nodes, "A", { href: true });
			var a2_nodes = children(a2);
			t10 = claim_text(a2_nodes, "Click here for Demo");
			a2_nodes.forEach(detach);
			strong0_nodes.forEach(detach);
			p1_nodes.forEach(detach);
			t11 = claim_space(nodes);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			img = claim_element(p2_nodes, "IMG", { src: true, alt: true, title: true });
			p2_nodes.forEach(detach);
			t12 = claim_space(nodes);
			p3 = claim_element(nodes, "P", {});
			var p3_nodes = children(p3);
			t13 = claim_text(p3_nodes, "This demo is based on the ");
			a3 = claim_element(p3_nodes, "A", { href: true });
			var a3_nodes = children(a3);
			t14 = claim_text(a3_nodes, "Regular Polygon");
			a3_nodes.forEach(detach);
			t15 = claim_text(p3_nodes, " sketch available in the p5js examples.");
			p3_nodes.forEach(detach);
			t16 = claim_space(nodes);
			h21 = claim_element(nodes, "H2", { id: true });
			var h21_nodes = children(h21);
			t17 = claim_text(h21_nodes, "Getting Started");
			h21_nodes.forEach(detach);
			t18 = claim_space(nodes);
			h30 = claim_element(nodes, "H3", { id: true });
			var h30_nodes = children(h30);
			t19 = claim_text(h30_nodes, "Installing");
			h30_nodes.forEach(detach);
			t20 = claim_space(nodes);
			claim_component(prism0.$$.fragment, nodes);
			t21 = claim_space(nodes);
			claim_component(prism1.$$.fragment, nodes);
			t22 = claim_space(nodes);
			h31 = claim_element(nodes, "H3", { id: true });
			var h31_nodes = children(h31);
			t23 = claim_text(h31_nodes, "Using");
			h31_nodes.forEach(detach);
			t24 = claim_space(nodes);
			claim_component(prism2.$$.fragment, nodes);
			t25 = claim_space(nodes);
			p4 = claim_element(nodes, "P", {});
			var p4_nodes = children(p4);
			t26 = claim_text(p4_nodes, "A local version will now be running on ");
			a4 = claim_element(p4_nodes, "A", { href: true });
			var a4_nodes = children(a4);
			t27 = claim_text(a4_nodes, "localhost:3000");
			a4_nodes.forEach(detach);
			t28 = claim_text(p4_nodes, ".");
			p4_nodes.forEach(detach);
			t29 = claim_space(nodes);
			h22 = claim_element(nodes, "H2", { id: true });
			var h22_nodes = children(h22);
			t30 = claim_text(h22_nodes, "Advanced");
			h22_nodes.forEach(detach);
			t31 = claim_space(nodes);
			h32 = claim_element(nodes, "H3", { id: true });
			var h32_nodes = children(h32);
			t32 = claim_text(h32_nodes, "Global and Instanced Modes");
			h32_nodes.forEach(detach);
			t33 = claim_space(nodes);
			p5 = claim_element(nodes, "P", {});
			var p5_nodes = children(p5);
			t34 = claim_text(p5_nodes, "P5 is able to run in either ");
			a5 = claim_element(p5_nodes, "A", { href: true });
			var a5_nodes = children(a5);
			t35 = claim_text(a5_nodes, "global or instance mode");
			a5_nodes.forEach(detach);
			t36 = claim_text(p5_nodes, ".");
			p5_nodes.forEach(detach);
			t37 = claim_space(nodes);
			p6 = claim_element(nodes, "P", {});
			var p6_nodes = children(p6);
			t38 = claim_text(p6_nodes, "This starter project uses ");
			strong1 = claim_element(p6_nodes, "STRONG", {});
			var strong1_nodes = children(strong1);
			t39 = claim_text(strong1_nodes, "global mode");
			strong1_nodes.forEach(detach);
			t40 = claim_text(p6_nodes, " by default to bring it in line with most of the online resources provided by the project.");
			p6_nodes.forEach(detach);
			t41 = claim_space(nodes);
			p7 = claim_element(nodes, "P", {});
			var p7_nodes = children(p7);
			t42 = claim_text(p7_nodes, "As stated on the P5 wiki:");
			p7_nodes.forEach(detach);
			t43 = claim_space(nodes);
			blockquote = claim_element(nodes, "BLOCKQUOTE", {});
			var blockquote_nodes = children(blockquote);
			p8 = claim_element(blockquote_nodes, "P", {});
			var p8_nodes = children(p8);
			t44 = claim_text(p8_nodes, "While this is convenient (and friendlier) it's important to note that this can lead to problems and confusion down the road when mixing other JS libraries or trying to embed multiple p5 sketches on the same page. A safer, more advanced methodology is to create a p5 sketch as an object \"instance\".");
			p8_nodes.forEach(detach);
			blockquote_nodes.forEach(detach);
			t45 = claim_space(nodes);
			p9 = claim_element(nodes, "P", {});
			var p9_nodes = children(p9);
			t46 = claim_text(p9_nodes, "The following examples are both functionally the same.");
			p9_nodes.forEach(detach);
			t47 = claim_space(nodes);
			h40 = claim_element(nodes, "H4", { id: true });
			var h40_nodes = children(h40);
			t48 = claim_text(h40_nodes, "Global Mode");
			h40_nodes.forEach(detach);
			t49 = claim_space(nodes);
			claim_component(prism3.$$.fragment, nodes);
			t50 = claim_space(nodes);
			h41 = claim_element(nodes, "H4", { id: true });
			var h41_nodes = children(h41);
			t51 = claim_text(h41_nodes, "Instanced Mode");
			h41_nodes.forEach(detach);
			t52 = claim_space(nodes);
			claim_component(prism4.$$.fragment, nodes);
			t53 = claim_space(nodes);
			p10 = claim_element(nodes, "P", {});
			var p10_nodes = children(p10);
			t54 = claim_text(p10_nodes, "This starter project will work with either mode, feel free to experiment with both.");
			p10_nodes.forEach(detach);
			t55 = claim_space(nodes);
			h33 = claim_element(nodes, "H3", { id: true });
			var h33_nodes = children(h33);
			t56 = claim_text(h33_nodes, "Using External Libraries");
			h33_nodes.forEach(detach);
			t57 = claim_space(nodes);
			p11 = claim_element(nodes, "P", {});
			var p11_nodes = children(p11);
			t58 = claim_text(p11_nodes, "To use an external library, e.g. ");
			a6 = claim_element(p11_nodes, "A", { href: true });
			var a6_nodes = children(a6);
			t59 = claim_text(a6_nodes, "qrcode-generator");
			a6_nodes.forEach(detach);
			t60 = claim_text(p11_nodes, ".");
			p11_nodes.forEach(detach);
			t61 = claim_space(nodes);
			ol0 = claim_element(nodes, "OL", {});
			var ol0_nodes = children(ol0);
			li0 = claim_element(ol0_nodes, "LI", {});
			var li0_nodes = children(li0);
			p12 = claim_element(li0_nodes, "P", {});
			var p12_nodes = children(p12);
			t62 = claim_text(p12_nodes, "Install the library with ");
			code0 = claim_element(p12_nodes, "CODE", {});
			var code0_nodes = children(code0);
			t63 = claim_text(code0_nodes, "npm install --save-dev qrcode-generator");
			code0_nodes.forEach(detach);
			t64 = claim_text(p12_nodes, ".");
			p12_nodes.forEach(detach);
			li0_nodes.forEach(detach);
			t65 = claim_space(ol0_nodes);
			li1 = claim_element(ol0_nodes, "LI", {});
			var li1_nodes = children(li1);
			p13 = claim_element(li1_nodes, "P", {});
			var p13_nodes = children(p13);
			t66 = claim_text(p13_nodes, "Add a ");
			code1 = claim_element(p13_nodes, "CODE", {});
			var code1_nodes = children(code1);
			t67 = claim_text(code1_nodes, "script");
			code1_nodes.forEach(detach);
			t68 = claim_text(p13_nodes, " tag to your ");
			code2 = claim_element(p13_nodes, "CODE", {});
			var code2_nodes = children(code2);
			t69 = claim_text(code2_nodes, "index.html");
			code2_nodes.forEach(detach);
			t70 = claim_text(p13_nodes, ".");
			p13_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			ol0_nodes.forEach(detach);
			t71 = claim_space(nodes);
			claim_component(prism5.$$.fragment, nodes);
			t72 = claim_space(nodes);
			ol1 = claim_element(nodes, "OL", { start: true });
			var ol1_nodes = children(ol1);
			li2 = claim_element(ol1_nodes, "LI", {});
			var li2_nodes = children(li2);
			t73 = claim_text(li2_nodes, "Import via ");
			code3 = claim_element(li2_nodes, "CODE", {});
			var code3_nodes = children(code3);
			t74 = claim_text(code3_nodes, "global.d.ts");
			code3_nodes.forEach(detach);
			t75 = claim_text(li2_nodes, ".");
			li2_nodes.forEach(detach);
			ol1_nodes.forEach(detach);
			t76 = claim_space(nodes);
			claim_component(prism6.$$.fragment, nodes);
			t77 = claim_space(nodes);
			ol2 = claim_element(nodes, "OL", { start: true });
			var ol2_nodes = children(ol2);
			li3 = claim_element(ol2_nodes, "LI", {});
			var li3_nodes = children(li3);
			t78 = claim_text(li3_nodes, "Use in ");
			code4 = claim_element(li3_nodes, "CODE", {});
			var code4_nodes = children(code4);
			t79 = claim_text(code4_nodes, "sketch.ts");
			code4_nodes.forEach(detach);
			t80 = claim_text(li3_nodes, ".");
			li3_nodes.forEach(detach);
			ol2_nodes.forEach(detach);
			t81 = claim_space(nodes);
			claim_component(prism7.$$.fragment, nodes);
			t82 = claim_space(nodes);
			p14 = claim_element(nodes, "P", {});
			var p14_nodes = children(p14);
			t83 = claim_text(p14_nodes, "See ");
			a7 = claim_element(p14_nodes, "A", { href: true });
			var a7_nodes = children(a7);
			t84 = claim_text(a7_nodes, "dblock/p5qr");
			a7_nodes.forEach(detach);
			t85 = claim_text(p14_nodes, " for a working sample.");
			p14_nodes.forEach(detach);
			t86 = claim_space(nodes);
			h23 = claim_element(nodes, "H2", { id: true });
			var h23_nodes = children(h23);
			t87 = claim_text(h23_nodes, "Copyright and License");
			h23_nodes.forEach(detach);
			t88 = claim_space(nodes);
			p15 = claim_element(nodes, "P", {});
			var p15_nodes = children(p15);
			t89 = claim_text(p15_nodes, "MIT License, see ");
			a8 = claim_element(p15_nodes, "A", { href: true });
			var a8_nodes = children(a8);
			t90 = claim_text(a8_nodes, "LICENSE");
			a8_nodes.forEach(detach);
			t91 = claim_text(p15_nodes, " for details.");
			p15_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h1, "id", "p5typescriptstarter");
			attr(a0, "href", "https://p5js.org/");
			attr(a1, "href", "https://www.typescriptlang.org/");
			attr(h20, "id", "demo");
			attr(a2, "href", "https://gaweph.github.io/p5-typescript-starter/");
			if (img.src !== (img_src_value = "https://gaweph.github.io/p5-typescript-starter/p5-typescript-demo.png?raw=true")) attr(img, "src", img_src_value);
			attr(img, "alt", "Demo");
			attr(img, "title", "Demo");
			attr(a3, "href", "https://p5js.org/examples/form-regular-polygon.html");
			attr(h21, "id", "gettingstarted");
			attr(h30, "id", "installing");
			attr(h31, "id", "using");
			attr(a4, "href", "http://localhost:3000");
			attr(h22, "id", "advanced");
			attr(h32, "id", "globalandinstancedmodes");
			attr(a5, "href", "https://github.com/processing/p5.js/wiki/Global-and-instance-mode");
			attr(h40, "id", "globalmode");
			attr(h41, "id", "instancedmode");
			attr(h33, "id", "usingexternallibraries");
			attr(a6, "href", "https://www.npmjs.com/package/qrcode-generator");
			attr(ol1, "start", "3");
			attr(ol2, "start", "4");
			attr(a7, "href", "https://github.com/dblock/p5qr");
			attr(h23, "id", "copyrightandlicense");
			attr(a8, "href", "https://github.com/Gaweph/p5-typescript-starter/blob/master/LICENSE");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, p0, anchor);
			append(p0, t2);
			append(p0, a0);
			append(a0, t3);
			append(p0, t4);
			append(p0, a1);
			append(a1, t5);
			append(p0, t6);
			insert(target, t7, anchor);
			insert(target, h20, anchor);
			append(h20, t8);
			insert(target, t9, anchor);
			insert(target, p1, anchor);
			append(p1, strong0);
			append(strong0, a2);
			append(a2, t10);
			insert(target, t11, anchor);
			insert(target, p2, anchor);
			append(p2, img);
			insert(target, t12, anchor);
			insert(target, p3, anchor);
			append(p3, t13);
			append(p3, a3);
			append(a3, t14);
			append(p3, t15);
			insert(target, t16, anchor);
			insert(target, h21, anchor);
			append(h21, t17);
			insert(target, t18, anchor);
			insert(target, h30, anchor);
			append(h30, t19);
			insert(target, t20, anchor);
			mount_component(prism0, target, anchor);
			insert(target, t21, anchor);
			mount_component(prism1, target, anchor);
			insert(target, t22, anchor);
			insert(target, h31, anchor);
			append(h31, t23);
			insert(target, t24, anchor);
			mount_component(prism2, target, anchor);
			insert(target, t25, anchor);
			insert(target, p4, anchor);
			append(p4, t26);
			append(p4, a4);
			append(a4, t27);
			append(p4, t28);
			insert(target, t29, anchor);
			insert(target, h22, anchor);
			append(h22, t30);
			insert(target, t31, anchor);
			insert(target, h32, anchor);
			append(h32, t32);
			insert(target, t33, anchor);
			insert(target, p5, anchor);
			append(p5, t34);
			append(p5, a5);
			append(a5, t35);
			append(p5, t36);
			insert(target, t37, anchor);
			insert(target, p6, anchor);
			append(p6, t38);
			append(p6, strong1);
			append(strong1, t39);
			append(p6, t40);
			insert(target, t41, anchor);
			insert(target, p7, anchor);
			append(p7, t42);
			insert(target, t43, anchor);
			insert(target, blockquote, anchor);
			append(blockquote, p8);
			append(p8, t44);
			insert(target, t45, anchor);
			insert(target, p9, anchor);
			append(p9, t46);
			insert(target, t47, anchor);
			insert(target, h40, anchor);
			append(h40, t48);
			insert(target, t49, anchor);
			mount_component(prism3, target, anchor);
			insert(target, t50, anchor);
			insert(target, h41, anchor);
			append(h41, t51);
			insert(target, t52, anchor);
			mount_component(prism4, target, anchor);
			insert(target, t53, anchor);
			insert(target, p10, anchor);
			append(p10, t54);
			insert(target, t55, anchor);
			insert(target, h33, anchor);
			append(h33, t56);
			insert(target, t57, anchor);
			insert(target, p11, anchor);
			append(p11, t58);
			append(p11, a6);
			append(a6, t59);
			append(p11, t60);
			insert(target, t61, anchor);
			insert(target, ol0, anchor);
			append(ol0, li0);
			append(li0, p12);
			append(p12, t62);
			append(p12, code0);
			append(code0, t63);
			append(p12, t64);
			append(ol0, t65);
			append(ol0, li1);
			append(li1, p13);
			append(p13, t66);
			append(p13, code1);
			append(code1, t67);
			append(p13, t68);
			append(p13, code2);
			append(code2, t69);
			append(p13, t70);
			insert(target, t71, anchor);
			mount_component(prism5, target, anchor);
			insert(target, t72, anchor);
			insert(target, ol1, anchor);
			append(ol1, li2);
			append(li2, t73);
			append(li2, code3);
			append(code3, t74);
			append(li2, t75);
			insert(target, t76, anchor);
			mount_component(prism6, target, anchor);
			insert(target, t77, anchor);
			insert(target, ol2, anchor);
			append(ol2, li3);
			append(li3, t78);
			append(li3, code4);
			append(code4, t79);
			append(li3, t80);
			insert(target, t81, anchor);
			mount_component(prism7, target, anchor);
			insert(target, t82, anchor);
			insert(target, p14, anchor);
			append(p14, t83);
			append(p14, a7);
			append(a7, t84);
			append(p14, t85);
			insert(target, t86, anchor);
			insert(target, h23, anchor);
			append(h23, t87);
			insert(target, t88, anchor);
			insert(target, p15, anchor);
			append(p15, t89);
			append(p15, a8);
			append(a8, t90);
			append(p15, t91);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(prism0.$$.fragment, local);
			transition_in(prism1.$$.fragment, local);
			transition_in(prism2.$$.fragment, local);
			transition_in(prism3.$$.fragment, local);
			transition_in(prism4.$$.fragment, local);
			transition_in(prism5.$$.fragment, local);
			transition_in(prism6.$$.fragment, local);
			transition_in(prism7.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism0.$$.fragment, local);
			transition_out(prism1.$$.fragment, local);
			transition_out(prism2.$$.fragment, local);
			transition_out(prism3.$$.fragment, local);
			transition_out(prism4.$$.fragment, local);
			transition_out(prism5.$$.fragment, local);
			transition_out(prism6.$$.fragment, local);
			transition_out(prism7.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(p0);
			if (detaching) detach(t7);
			if (detaching) detach(h20);
			if (detaching) detach(t9);
			if (detaching) detach(p1);
			if (detaching) detach(t11);
			if (detaching) detach(p2);
			if (detaching) detach(t12);
			if (detaching) detach(p3);
			if (detaching) detach(t16);
			if (detaching) detach(h21);
			if (detaching) detach(t18);
			if (detaching) detach(h30);
			if (detaching) detach(t20);
			destroy_component(prism0, detaching);
			if (detaching) detach(t21);
			destroy_component(prism1, detaching);
			if (detaching) detach(t22);
			if (detaching) detach(h31);
			if (detaching) detach(t24);
			destroy_component(prism2, detaching);
			if (detaching) detach(t25);
			if (detaching) detach(p4);
			if (detaching) detach(t29);
			if (detaching) detach(h22);
			if (detaching) detach(t31);
			if (detaching) detach(h32);
			if (detaching) detach(t33);
			if (detaching) detach(p5);
			if (detaching) detach(t37);
			if (detaching) detach(p6);
			if (detaching) detach(t41);
			if (detaching) detach(p7);
			if (detaching) detach(t43);
			if (detaching) detach(blockquote);
			if (detaching) detach(t45);
			if (detaching) detach(p9);
			if (detaching) detach(t47);
			if (detaching) detach(h40);
			if (detaching) detach(t49);
			destroy_component(prism3, detaching);
			if (detaching) detach(t50);
			if (detaching) detach(h41);
			if (detaching) detach(t52);
			destroy_component(prism4, detaching);
			if (detaching) detach(t53);
			if (detaching) detach(p10);
			if (detaching) detach(t55);
			if (detaching) detach(h33);
			if (detaching) detach(t57);
			if (detaching) detach(p11);
			if (detaching) detach(t61);
			if (detaching) detach(ol0);
			if (detaching) detach(t71);
			destroy_component(prism5, detaching);
			if (detaching) detach(t72);
			if (detaching) detach(ol1);
			if (detaching) detach(t76);
			destroy_component(prism6, detaching);
			if (detaching) detach(t77);
			if (detaching) detach(ol2);
			if (detaching) detach(t81);
			destroy_component(prism7, detaching);
			if (detaching) detach(t82);
			if (detaching) detach(p14);
			if (detaching) detach(t86);
			if (detaching) detach(h23);
			if (detaching) detach(t88);
			if (detaching) detach(p15);
		}
	};
}

// (19:0) <PostContents>
function create_default_slot(ctx) {
	let openingithub;
	let t;
	let postsection;
	let current;

	openingithub = new OpenInGithub({
			props: {
				url: "https://github.com/Gaweph/p5-typescript-starter"
			}
		});

	postsection = new PostSection({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(openingithub.$$.fragment);
			t = space();
			create_component(postsection.$$.fragment);
		},
		l(nodes) {
			claim_component(openingithub.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postsection.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(openingithub, target, anchor);
			insert(target, t, anchor);
			mount_component(postsection, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection_changes.$$scope = { dirty, ctx };
			}

			postsection.$set(postsection_changes);
		},
		i(local) {
			if (current) return;
			transition_in(openingithub.$$.fragment, local);
			transition_in(postsection.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(openingithub.$$.fragment, local);
			transition_out(postsection.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(openingithub, detaching);
			if (detaching) detach(t);
			destroy_component(postsection, detaching);
		}
	};
}

function create_fragment(ctx) {
	let postcontents;
	let current;

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "p5-typescript-starter";
const date = "Sat Aug 19 2017 21:55:47 GMT+0000 (Coordinated Universal Time)";

function instance($$self) {
	const tags = ["p5js", "starter-project", "typescript"];
	const projects = [];
	return [];
}

class P5_typescript_starter extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default P5_typescript_starter;
//# sourceMappingURL=p5-typescript-starter.svelte.js.map
